import Navigation from "components/ui/Navigation";
import { useMatches } from "react-router-dom";

const AppNavigation = () => {
  const matches = useMatches();

  return <Navigation matches={matches} />;
};

export default AppNavigation;
